<template>
  <div class="history">
    <sirui-search
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    ></sirui-search>
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="false"
        :setting="false"
        :customVisible="false"
        :columns="columnList"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @chooseClick="chooseClick"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :type="item.type"
          :visible="item.visible"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
        >
        </vxe-table-column>
      </sirui-table>
    </div>
    <sirui-upload
      :action="action"
      :isShowDownTemplateBtn="true"
      @getData="getData"
      ref="SiruiUpload"
      :data="token"
    ></sirui-upload>
  </div>
</template>

<script>
  import SiruiUpload from '@/components/SiruiUpload';
  import API from '@/api/masterData/paymentHistory';
  export default {
    name: 'paymentHistory',
    data() {
      return {
        query: {
          partnerName: null,
          partnerBankAccount: null,
        },
        load: false,
        menuButtonList: [],
        tableData: [],
        columnList: [],
        action: API.IMPORT_HISTORY,
      };
    },
    computed: {
      token() {
        return {
          access_token: this.userInfo.access_token,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          tenantCode: this.userInfo.tenantCode,
        };
      },
      searchColumns() {
        return [
          {
            prop: 'partnerName',
            name: '投送人姓名',
            type: 'input',
          },
          {
            prop: 'partnerBankAccount',
            name: '投送人银行账户',
            type: 'input',
          },
        ];
      },
      columnListDefault() {
        return [
          // { type: 'checkbox', width: 50 },
          { type: 'seq', title: '序号', width: 50 },
          {
            field: 'partnerName',
            title: '投送人姓名',
            sortable: true,
          },
          { field: 'partnerBankAccount', title: '投送人银行账户' },
          { field: 'accountBankBranch', title: '投送人开户行名称' },
        ];
      },
    },
    mounted() {
      this.getButtonList();
      this.getData();
    },
    methods: {
      //每页条数
      handleSizeChange() {
        this.getData();
      },
      //第几页
      handleCurrentChange() {
        this.getData();
      },
      async getData() {
        this.load = true;
        const { pageSize, pageNum } = this.$refs.siruiTable.page;
        const params = {
          ...this.query,
          pageSize,
          pageNum,
        };
        let res = await this.$axios.post(API.QUERY_DATA, params);
        if (res) {
          console.log('res', res);
          this.load = false;
          if (res.data.code == 0) {
            this.tableData = res.data.data.records;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          }
        }
      },
      //搜索
      searchBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getData();
      },
      //重置
      resetBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getData();
      },
      // 按钮
      chooseClick(type) {
        if (type == 'import') {
          this.$refs.SiruiUpload.openDialog(true, '105');
        }
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e || [];
          this.getColumnInfo();
        });
      },
      //获取当前列
      getColumnInfo() {
        this.getColumnList(this.columnListDefault).then((res) => {
          if (res.length > 0) {
            this.columnList = res.map((item) => {
              let obj = { ...this.columnListDefault.find((it) => it.field == item.field), ...item };
              return obj;
            });
          }
        });
      },
    },
    components: {
      SiruiUpload,
    },
  };
</script>

<style></style>
